// src/components/ui.js
// Küçük, tekrar kullanılan arayüz bileşenleri.
import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Icon from './Icon';
import { gameIcon, categoryOf } from '../data';

export function GameCard({ game, headingLevel = 3 }) {
  const H = `h${headingLevel}`;
  const cat = categoryOf(game.category);
  return (
    <article className="game-card" style={{ '--c': game.accent }}>
      <div className="game-top">
        <img className="game-icon" src={gameIcon(game.id)} alt="" width="72" height="72" loading="lazy" decoding="async" />
        <span className="game-pill">{game.players}</span>
      </div>
      <H className="game-title">
        <Link to={`/oyun/${game.id}`}>{game.name}</Link>
      </H>
      <p className="game-desc">{game.short}</p>
      <ul className="game-tags">
        {cat && <li>{cat.name}</li>}
        <li>{game.level}</li>
        {game.popular && <li>Popüler</li>}
      </ul>
      <div className="game-foot">
        <span className="game-cta">Hemen oyna <Icon name="arrow" size="sm" /></span>
        <Link className="game-sub" to={`/rehber/${game.id}`}>Kurallar</Link>
      </div>
    </article>
  );
}

export function Breadcrumbs({ items }) {
  return (
    <nav aria-label="Sayfa yolu">
      <ol className="breadcrumbs">
        {items.map((it, i) => (
          <li key={i}>{it.path && i < items.length - 1 ? <Link to={it.path}>{it.name}</Link> : <span aria-current="page">{it.name}</span>}</li>
        ))}
      </ol>
    </nav>
  );
}

export function Faq({ items }) {
  if (!items || !items.length) return null;
  return (
    <div className="faq">
      {items.map((f, i) => (
        <details key={i} open={i === 0}>
          <summary>{f.q}</summary>
          <p>{f.a}</p>
        </details>
      ))}
    </div>
  );
}

export function RankBadge({ n }) {
  return <span className={`rank${n <= 3 ? ` r${n}` : ''}`}>{n}</span>;
}

export function TopList({ entries, loading, rows = 5, emptyText = 'Henüz puan alan yok. İlk sen ol!' }) {
  if (loading) {
    return (
      <ul className="lb-list" aria-busy="true">
        {Array.from({ length: rows }).map((_, i) => (
          <li key={i}>
            <span className="rank">{i + 1}</span>
            <span className="skeleton" style={{ flex: 1 }} />
          </li>
        ))}
      </ul>
    );
  }
  if (!entries || !entries.length) return <p className="text-secondary small mb-0">{emptyText}</p>;
  return (
    <ol className="lb-list">
      {entries.map((e, i) => (
        <li key={e.uid || i}>
          <RankBadge n={i + 1} />
          <Link to={`/profil/${encodeURIComponent(e.nickname)}`}>{e.nickname}</Link>
          <span className="score">{e.score}</span>
        </li>
      ))}
    </ol>
  );
}

/** Erişilebilir, bağımsız modal (Bootstrap JS gerektirmez). */
export function Modal({ open, onClose, title, children, footer }) {
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const prev = document.activeElement;
    const onKey = (e) => e.key === 'Escape' && onClose();
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    setTimeout(() => ref.current && ref.current.focus(), 0);
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
      if (prev && prev.focus) prev.focus();
    };
  }, [open, onClose]);
  if (!open) return null;
  return (
    <div className="oy-modal-backdrop" onMouseDown={(e) => e.target === e.currentTarget && onClose()}>
      <div className="oy-modal-box" role="dialog" aria-modal="true" aria-labelledby="oy-modal-title" tabIndex={-1} ref={ref}>
        <div className="oy-modal-head">
          <h2 id="oy-modal-title">{title}</h2>
          <button type="button" className="oy-modal-close" onClick={onClose} aria-label="Kapat">
            <Icon name="close" />
          </button>
        </div>
        <div className="oy-modal-body">{children}</div>
        {footer && <div className="oy-modal-foot">{footer}</div>}
      </div>
    </div>
  );
}
